import set from "lodash/set";
import get from "lodash/get";

import {
  SHOW_FETCH_START,
  SHOW_FETCH_SUCCESS,
  SHOW_FETCH_ERROR,
  SHOW_PUT_SUCCESS,
  MEDIA_FILE_FETCH_START,
  MEDIA_FILE_FETCH_END,
  SHOW_EPISODE_LIST_FETCH_START,
  SHOW_EPISODE_LIST_FETCH_SUCCESS,
  SHOW_EPISODE_LIST_FETCH_ERROR,
  SHOW_EPISODE_FETCH_START,
  SHOW_EPISODE_FETCH_SUCCESS,
  SHOW_EPISODE_FETCH_ERROR,
  EPISODE_PUT_START,
  EPISODE_PUT_SUCCESS,
  EPISODE_PUT_ERROR,
  EPISODE_PUT_VALID,
  EPISODE_PUT_INVALID,
  SHOW_CHECK_REDIRECT,
  SHOW_FETCH_BY_UUIDS,
} from "../actions/shows";
import { ENABLE_EXCLUSIVE_CONTENT } from "../action_managers/subscriptions";
import { AD_PLACEMENTS_MODAL_SAVE_SUCCESS } from "../actions/ad_placements_modal";

import { EPISODE_DELETE_SUCCESS } from "../actions/episode_delete_modal";

import { UPLOAD_MODAL_SUCCESS } from "../actions/upload_modal";
import { getActionNames, httpReducer, reduceReducers } from "../lib/create-action";
import { showFeedImportActionName } from "../actions/feed_import";
import { ENABLE_PAYMENTS } from "../action_managers/shows";

const initialState = {
  isLoading: false,
  shows: {},
};

function getShow(state = initialState, action) {
  switch (action.type) {
    case SHOW_FETCH_START:
    case getActionNames(ENABLE_PAYMENTS).started:
    case getActionNames(ENABLE_EXCLUSIVE_CONTENT).started:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case getActionNames(showFeedImportActionName).success: {
      let show = action.payload.resp;
      let newShow = { [show.uuid]: show };
      let shows = Object.assign({}, state.shows, newShow);
      return {
        isLoading: false,
        shows: shows,
      };
    }
    case getActionNames(ENABLE_EXCLUSIVE_CONTENT).success:
    case getActionNames(ENABLE_PAYMENTS).success: {
      let show = action.payload.resp;
      return { ...state, shows: { ...state.shows, [show.uuid]: show }, isLoading: false };
    }
    case SHOW_FETCH_SUCCESS:
    case SHOW_PUT_SUCCESS:
      var allShows = {};
      for (var fetchedShow of action.shows) {
        allShows[fetchedShow.uuid] = fetchedShow;
      }
      var fetchedShows = Object.assign({}, state.shows, allShows);
      return {
        isLoading: false,
        shows: fetchedShows,
      };
    case getActionNames(ENABLE_EXCLUSIVE_CONTENT).failure:
    case getActionNames(ENABLE_EXCLUSIVE_CONTENT).failureBadRequest:
    case SHOW_FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case getActionNames(SHOW_CHECK_REDIRECT).success: {
      let show = { ...action.data.show, redirectVerified: action.payload.resp };
      return {
        isLoading: false,
        shows: Object.assign({}, state.shows, { [show.uuid]: show }),
      };
    }
    default:
      return state;
  }
}

const getShowsByUUIDs = httpReducer(SHOW_FETCH_BY_UUIDS, initialState, {
  success: (state, action) => ({
    shows: {
      ...state.shows,
      ...action.payload.resp.reduce((agg, show) => (agg[show.uuid] = show), {}),
    },
    ...state,
  }),
});

export const shows = reduceReducers(getShow, getShowsByUUIDs);

const initialMediaState = {};

export function mediaFiles(state = initialMediaState, action) {
  switch (action.type) {
    case MEDIA_FILE_FETCH_START:
      var newState = {};
      for (var uuid of Object.keys(state)) {
        newState[uuid] = Object.assign({}, state[uuid]);
      }
      if (action.mediaFileUUID) {
        set(newState, action.mediaFileUUID + ".isLoading", true);
      }
      return newState;
    case MEDIA_FILE_FETCH_END: {
      let newState = { ...state };
      if (action.mediaFile && action.mediaFile.uuid) {
        newState[action.mediaFile.uuid] = action.mediaFile;
        newState[action.mediaFile.uuid].isLoading = false;
      }
      return newState;
    }
    case UPLOAD_MODAL_SUCCESS:
      newState = {};
      for (uuid of Object.keys(state)) {
        newState[uuid] = Object.assign({}, state[uuid]);
      }
      if (action.mediaFiles) {
        for (var f of action.mediaFiles) {
          newState[f.uuid] = f;
          newState[f.uuid].isLoading = false;
        }
      }
      return newState;
    default:
      return state;
  }
}

const initialShowEpisodesState = {};

export function episodesByShow(state = initialShowEpisodesState, action) {
  switch (action.type) {
    case SHOW_EPISODE_LIST_FETCH_START: {
      const currentEpisodes = get(state, [action.showUUID, "episodes"], {});
      return Object.assign({}, state, {
        [action.showUUID]: {
          isLoading: true,
          episodes: currentEpisodes,
        },
      });
    }
    case SHOW_EPISODE_LIST_FETCH_SUCCESS:
      var episodes = {};
      if (action.episodes && action.episodes.length > 0) {
        for (var episode of action.episodes) {
          episodes[episode.uuid] = episode;
        }
      }
      return Object.assign({}, state, {
        [action.showUUID]: {
          isLoading: false,
          episodes: episodes,
        },
      });
    case SHOW_EPISODE_LIST_FETCH_ERROR:
      return Object.assign({}, state, {
        [action.showUUID]: {
          isLoading: false,
          errorMessage: action.errorMessage,
        },
      });
    case SHOW_EPISODE_FETCH_START:
    case EPISODE_PUT_START:
      var newState = deepCopyEpisodeState(state);
      var showUUID = action.showUUID;
      if (typeof newState[showUUID] === "undefined") {
        newState[showUUID] = {
          episodes: {},
        };
      }
      newState[showUUID]["isLoading"] = true;
      newState[showUUID]["validationErrors"] = [];
      newState[showUUID]["newUUID"] = null;
      if (action.type === EPISODE_PUT_START) {
        newState[showUUID]["isPutting"] = true;
      }
      return newState;
    case SHOW_EPISODE_FETCH_SUCCESS:
    case EPISODE_PUT_SUCCESS:
    case AD_PLACEMENTS_MODAL_SAVE_SUCCESS:
      showUUID = action.episode.showUUID;
      newState = deepCopyEpisodeState(state);
      newState[showUUID]["isLoading"] = false;
      newState[showUUID]["episodes"][action.episode.uuid] = action.episode;

      if (action.type === EPISODE_PUT_SUCCESS) {
        newState[showUUID]["isSuccess"] = true;
        newState[showUUID]["isPutting"] = false;
        newState[showUUID]["newUUID"] = action.episode.uuid;
      }
      return newState;

    case EPISODE_PUT_VALID:
      showUUID = action.episode.showUUID;
      newState = deepCopyEpisodeState(state);
      newState[showUUID]["isLoading"] = false;
      return newState;

    case SHOW_EPISODE_FETCH_ERROR:
    case EPISODE_PUT_ERROR:
    case EPISODE_PUT_INVALID:
      newState = deepCopyEpisodeState(state);
      showUUID = action.showUUID;
      newState[showUUID]["isLoading"] = false;
      newState[showUUID]["isPutting"] = false;
      newState[showUUID]["validationErrors"] = action.validationErrors;
      return newState;
    case EPISODE_DELETE_SUCCESS:
      newState = deepCopyEpisodeState(state);
      showUUID = action.showUUID;
      var episodeUUID = action.episodeUUID;
      if (
        newState[showUUID] &&
        newState[showUUID].episodes &&
        newState[showUUID].episodes[episodeUUID]
      ) {
        delete newState[showUUID].episodes[episodeUUID];
      }
      return newState;
    default:
      return state;
  }
}

function deepCopyEpisodeState(state) {
  var newState = {};
  for (var uuid of Object.keys(state)) {
    newState[uuid] = {
      isLoading: state[uuid].isLoading,
      errorMessage: state[uuid].errorMessage,
      episodes: {},
    };
    if (Object.keys(state[uuid].episodes || {}).length) {
      for (var episodeUUID of Object.keys(state[uuid].episodes)) {
        newState[uuid].episodes[episodeUUID] = Object.assign({}, state[uuid].episodes[episodeUUID]);
      }
    }
  }
  return newState;
}
